/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { LabelValueComponent } from './label-value';
export * from './label-value-constants';
export * from './label-value';
export * from './label-value-component-delegate';
export function defineLabelValueComponent() {
    defineCustomElement(LabelValueComponent);
}
